export class Validator{
    constructor() {
        this.fields = {}
    }

    add(field, validator, valid){
        this.fields[field] = {
            validator: validator,
            validated: valid,
            edited: false
        }
    }

    check(field, value){
        const props = this.fields[field]
        const valid = props.validator(value)
        props.edited = true
        props.validated = valid
        return valid
    }

    isValidated(field){
        return this.fields[field].validated
    }

    get disableSubmit(){
        return !!Object.values(this.fields).find(prop => !prop.validated)
    }

    displayError(field){
        const props = this.fields[field]
        return props.edited && !props.validated
    }
}

export function notEmpty(value){
    return /[^\s]+/.test(value)
}

export function validEmail(email){
    return /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/.test(email)
}
